module.exports = __webpack_public_path__ + "img/bg-wave-grey@2x.29144ab5.png";